module.exports = __webpack_public_path__ + "static/index-image-new-smaller-f84b05bfe7e44971f2e61ac031a048e2.jpg";